import { render, staticRenderFns } from "./EvaluationSection.vue?vue&type=template&id=5dd29e23&scoped=true"
import script from "./EvaluationSection.vue?vue&type=script&lang=js"
export * from "./EvaluationSection.vue?vue&type=script&lang=js"
import style0 from "./EvaluationSection.vue?vue&type=style&index=0&id=5dd29e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd29e23",
  null
  
)

export default component.exports